import React from "react";
import { motion } from "framer-motion";
import { RevealLines, easeLux } from "@/lib/motion";

export default function PageHeader({ overline, titleLines, subtitle, image }) {
  return (
    <header className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden">
      {image && (
        <>
          <motion.div
            initial={{ scale: 1.15, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.28 }}
            transition={{ duration: 1.6, ease: easeLux }}
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#060A17]/70 via-[#060A17]/85 to-[#060A17]" />
        </>
      )}
      <div className="absolute inset-0 radial-glow" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-8">
        {overline && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.8 }}
            className="overline text-gold mb-6"
          >
            {overline}
          </motion.p>
        )}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-[#F8FAFC] max-w-4xl">
          <RevealLines lines={titleLines} startDelay={0.15} />
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.9, ease: easeLux }}
            className="mt-7 text-lg text-[#94A3B8] max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </header>
  );
}
